import React from 'react';
import { Form } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import Addon from './Addon';
const Addons = ({ name, formAddOns, isEdit }) => {
  let addons = useSelector((state) => state.space?.addons?.data || []);
  if(isEdit && formAddOns) {
    const filterdAddons = []
    addons.forEach((element, index) => {
      filterdAddons.push(element)
      formAddOns.forEach(fAddOns => {
        if (element.id === fAddOns.id && fAddOns.isAvailable){
          filterdAddons[index] = {...element,isAvailable: true, value:fAddOns };
        }
      })
    });
    addons = filterdAddons;
  }
  
  return (
      <>
      {/* <h3>Addons</h3>
        <div className="amenities-checkbox-wrapper">
          {addons.map((addon, index) => (
            <Form.Item name={[...name, index]}>
              <Addon name={addon.name} addonId={addon.id} index={index} initial={addon.value || null} />
            </Form.Item>
          ))}
        </div> */}
      </>
  );
};

export default Addons;
